<div class="row" *ngIf="operacao; else carregando">
  <div class="bn-form-group col-md-5">
    <label class="form-label"><b>Nome ou razão social</b></label>
    <input type="text" class="form-control" name="razaoSocialClienteFinal" data-toggle="tooltip"
           title="{{operacao.razaoSocialClienteFinal}}" [(ngModel)]="operacao.razaoSocialClienteFinal"
           [disabled]="!modoEdicao && !emInclusao" [required]="operacao.codigoTipoOperacao == 'L'"
           [bnComparacaoA]="operacao.razaoSocialClienteFinal" [bnComparacaoB]="model.razaoSocialClienteFinal" />
  </div>
  <div class="bn-form-group col-md-3">
    <label class="form-label"><b>CNPJ/CPF</b></label>
    <input type="text" class="form-control" name="cnpjClienteFinal" [(ngModel)]="operacao.cnpjClienteFinal"
           bnMask="CNPJCPF" [disabled]="!(modoEdicao && modoAditivo && alteracaoClienteFinalAditivo) && !emInclusao" [bnComparacaoA]="operacao.cnpjClienteFinal"
           [bnComparacaoB]="model.cnpjClienteFinal" required />
  </div>
  <div class="bn-form-group col-md-4">
    <label for="naturezaClienteFinalSelect" class="block form-label"><b>Natureza jurídica</b></label>
    <select *ngIf="(modoEdicao && modoAditivo && alteracaoClienteFinalAditivo) || (modoEdicao && modoRetificacao) || emInclusao" class="form-select"
            id="naturezaClienteFinalSelect" name="naturezaClienteFinalSelect" required
            #naturezaClienteFinalSelect="ngModel" [(ngModel)]="operacao.naturezaClienteFinal">
      <option value=""></option>
      <option *ngFor="let natureza of dadosDominio.naturezas" [value]="natureza.id">{{natureza.nome}}
      </option>
    </select>
    <input *ngIf="!(modoEdicao && modoAditivo && alteracaoClienteFinalAditivo) && !(modoEdicao && modoRetificacao) && !emInclusao" type="text" class="form-control"
           value="{{operacao.detalheCreditoLivre?.nomeNaturezaClienteFinal}}"
           [bnComparacaoA]="operacao.detalheCreditoLivre?.nomeNaturezaClienteFinal"
           [bnComparacaoB]="model.detalheCreditoLivre?.nomeNaturezaClienteFinal" readonly disabled/>
  </div>
  <div class="bn-form-group col-md-6">
    <label for="cnaeClienteFinalSelect" class="block form-label"><b>CNAE</b></label>
    <input *ngIf="(modoEdicao && modoAditivo && alteracaoClienteFinalAditivo) || (modoEdicao && modoRetificacao) || emInclusao" type="text" class="form-control"
           id="cnaeClienteFinalSelect" (selectItem)="atribuiCnaeClienteFinal($event)"
           value="{{model.cnaeClienteFinal}} - {{model.detalhe?.nomeCnaeClienteFinal}}"
           [ngbTypeahead]="procuraCnae" [resultFormatter]="formataCnae" [disabled]="!campoHabilitado('cnae')" />
    <input *ngIf="!(modoEdicao && modoAditivo && alteracaoClienteFinalAditivo) && !(modoEdicao && modoRetificacao) && !emInclusao" type="text" class="form-control"
           value="{{model.cnaeClienteFinal}} - {{operacao.detalhe?.nomeCnaeClienteFinal}}"
           [bnComparacaoA]="operacao.detalhe?.nomeCnaeClienteFinal"
           [bnComparacaoB]="model.detalhe?.nomeCnaeClienteFinal" readonly disabled/>
  </div>
  <div class="bn-form-group col-md-6">
    <label for="cnaeEnquadramentoSelect" class="block form-label"><b>CNAE de Enquadramento </b> <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                                                                                   ngbTooltip="Somente precisa ser preenchido se for exigida a informação de CNAE de enquadramento."></i></label>
    <input *ngIf="(modoEdicao && modoRetificacao) || emInclusao" type="text" class="form-control"
           id="cnaeEnquadramentoSelect" (selectItem)="atribuiCnaeEnquadramento($event)"
           value="{{model.cnaeEnquadramento}} - {{model.detalhe?.nomeCnaeEnquadramento}}"
           [ngbTypeahead]="procuraCnae" [resultFormatter]="formataCnae" [disabled]="!campoHabilitado('cnaeEnquadramento')" />
    <input *ngIf="!(modoEdicao && modoRetificacao) && !emInclusao" type="text" class="form-control"
           value="{{model.cnaeEnquadramento}} - {{operacao.detalhe?.nomeCnaeEnquadramento}}"
           [bnComparacaoA]="operacao.detalhe?.nomeCnaeEnquadramento"
           [bnComparacaoB]="model.detalhe?.nomeCnaeEnquadramento" readonly disabled/>
  </div>
  <div class="bn-form-group col-md-6" *ngIf="tranche?.taxaStopLossPorteGrandeEmpresa">
    <label for="cnaeGrandeEmpresaSelect" class="block form-label"><b>CNAE Portaria Grande Empresa</b></label>
    <input *ngIf="(modoEdicao && modoRetificacao) || emInclusao" class="form-control"
           id="cnaeGrandeEmpresaSelect" (selectItem)="atribuiCnaeGrandeEmpresa($event)"
           (change)="inspecionaCnaeGrandeEmpresa($event)"
           value="{{model.cnaePortariaGrandeEmpresa}} - {{model.detalheCreditoLivre?.nomeCnaePortariaGrandeEmpresa}}"
           [ngbTypeahead]="procuraCnae" [resultFormatter]="formataCnae" />
    <input *ngIf="!(modoEdicao && modoRetificacao) && !emInclusao" type="text" class="form-control"
           value="{{operacao.detalheCreditoLivre?.nomeCnaePortariaGrandeEmpresa}}"
           [bnComparacaoA]="operacao.detalheCreditoLivre?.nomeCnaePortariaGrandeEmpresa"
           [bnComparacaoB]="model.detalheCreditoLivre?.nomeCnaePortariaGrandeEmpresa" readonly disabled/>
  </div>
  <div class="bn-form-group col-md-6" *ngIf="modalidadeGarantia == 'FGE'">
    <label for="codigoValidacaoProjeto" class="block form-label"><b>Código de validação da avaliação do projeto</b></label>
    <input type="text" class="form-control" id="codigoValidacaoProjeto"
           value="{{model.codigoValidacaoProjeto}}"
           [(ngModel)]="operacao.codigoValidacaoProjeto" required
           pattern="{{uuidPattern}}"
           [disabled]="!(modoEdicao && modoRetificacao) && !emInclusao">
  </div>
  <div class="bn-form-group col-md-2">
    <label class="block form-label"><b>Data da receita bruta</b></label>
    <bn-datepicker name="dataReferenciaReceitaBruta" [(ngModel)]="operacao.dataReferenciaReceitaBruta"
                   [disabled]="(!modoEdicao && !emInclusao) || (modoAditivo && !alteracaoClienteFinalAditivo)"
                   [required]="operacao.codigoTipoOperacao == 'L'"></bn-datepicker>
  </div>
  <div class="bn-form-group col-md-2">
    <label class="block form-label"><b>Receita bruta</b> <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                                            ngbTooltip="Receita bruta original da operação. Em caso de aditivo, consultar o valor novo na aba de aditivos."></i></label>
    <input type="text" class="form-control" name="receitaBrutaClienteFinal"
           [(ngModel)]="operacao.receitaBrutaClienteFinal" bnMask="MOEDA"
           [disabled]="!(modoEdicao && modoAditivo && alteracaoClienteFinalAditivo) && !(modoEdicao && modoRetificacao) && !emInclusao"
           [required]="operacao.codigoTipoOperacao == 'L'" />
  </div>
  <div class="bn-form-group col-md-2">
    <label for="tipoReceitaBrutaSelect" class="block form-label"><b>Tipo da receita bruta</b></label>
    <select class="form-select" id="tipoReceitaBrutaSelect" name="tipoReceitaBrutaSelect" required
            #tipoReceitaBrutaSelect="ngModel" [(ngModel)]="operacao.tipoReceitaBruta"
            [disabled]="(!modoEdicao && !emInclusao) || (modoAditivo && !alteracaoClienteFinalAditivo)">
      <option value=""></option>
      <option value="E">Efetiva</option>
      <option value="P">Prevista</option>
    </select>
  </div>
  <div class="bn-form-group col-md-3" *ngIf="exibeMEI">
    <label class="block form-label"><b>Microempreendedor Individual</b><i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                                                          ngbTooltip="Indica se a beneficiária é microempreendedor individual ou não."></i></label>
    <select class="form-select" id="indicadorMicroempreendedorIndividual" name="indicadorMicroempreendedorIndividual" required
            [(ngModel)]="operacao.indicadorMicroempreendedorIndividual" (change)="atribuirNovoValorPCD($event.target.value)"
            [disabled]="!campoHabilitado('indicadorMicroempreendedorIndividual')">
      <option value=""></option>
      <option value="S">Sim</option>
      <option value="N">Não</option>
    </select>
  </div>
  <div *ngIf="exibirCampoIndicadorPessoaDeficiencia" class="bn-form-group col-md-3">
    <label class="block form-label"><b>Pessoa com Deficiência (PCD)</b><i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                                                          ngbTooltip="Indica se a beneficiária é pessoa portadora de deficiência ou não."></i></label>
    <select class="form-select" id="indicadorPessoaComDeficiencia" name="indicadorPessoaComDeficiencia"
            [(ngModel)]="operacao.indicadorPessoaComDeficiencia"
            [disabled]="!campoHabilitado('indicadorPessoaComDeficiencia') || operacao.indicadorMicroempreendedorIndividual !== 'S'">
      <option value=""></option>
      <option value="S">Sim</option>
      <option value="N">Não</option>
    </select>
  </div>
  <div class="bn-form-group col-md-6">
    <label class="form-label" for="municipioClienteFinalSelect"><b>Município</b></label>
    <input *ngIf="modoEdicao || emInclusao" type="text" class="form-control"
           id="municipioClienteFinalSelect" required (selectItem)="atribuiMunicipioClienteFinal($event)"
           value="{{model.enderecoSedeClienteFinal?.nomeMunicipio}}" [ngbTypeahead]="procuraMunicipio"
           [resultFormatter]="formataMunicipio" />
    <input *ngIf="!modoEdicao && !emInclusao" type="text" class="form-control"
           value="{{operacao.enderecoSedeClienteFinal?.nomeMunicipio}}"
           [bnComparacaoA]="operacao.enderecoSedeClienteFinal?.nomeMunicipio"
           [bnComparacaoB]="model.enderecoSedeClienteFinal?.nomeMunicipio" readonly disabled/>
  </div>
  <div class="bn-form-group col-md-6">
    <label class="form-label" for="tipoLogradouroSelect"><b>Tipo de logradouro</b></label>
    <select *ngIf="modoEdicao || emInclusao" class="form-select" id="tipoLogradouroSelect"
            name="tipoLogradouroSelect" required #tipoLogradouroSelect="ngModel"
            [(ngModel)]="operacao.enderecoSedeClienteFinal.tipoLogradouro">
      <option value=""></option>
      <option [value]="tipoLogradouro.id" *ngFor="let tipoLogradouro of dadosDominio.tiposLogradouro">
        {{tipoLogradouro.nome}}</option>
    </select>
    <input *ngIf="!modoEdicao && !emInclusao" type="text" class="form-control"
           value="{{operacao.enderecoSedeClienteFinal?.nomeTipoLogradouro}}"
           [bnComparacaoA]="operacao.enderecoSedeClienteFinal?.nomeTipoLogradouro"
           [bnComparacaoB]="model.enderecoSedeClienteFinal?.nomeTipoLogradouro" readonly disabled/>
  </div>
  <div class="bn-form-group col-md-6">
    <label class="form-label"><b>Logradouro</b></label>
    <input type="text" class="form-control" name="nomeLogradouro"
           [(ngModel)]="operacao.enderecoSedeClienteFinal.nomeLogradouro" [disabled]="!modoEdicao && !emInclusao"
           [required]="operacao.codigoTipoOperacao == 'L'"
           [bnComparacaoA]="operacao.enderecoSedeClienteFinal?.nomeLogradouro"
           [bnComparacaoB]="model.enderecoSedeClienteFinal?.nomeLogradouro" />
  </div>
  <div class="bn-form-group col-md-2">
    <label class="form-label"><b>Número</b></label>
    <input type="text" class="form-control" name="numeroLogradouro"
           [(ngModel)]="operacao.enderecoSedeClienteFinal.numeroLogradouro"
           [disabled]="!modoEdicao && !emInclusao" [required]="operacao.codigoTipoOperacao == 'L'"
           [bnComparacaoA]="operacao.enderecoSedeClienteFinal?.numeroLogradouro"
           [bnComparacaoB]="model.enderecoSedeClienteFinal?.numeroLogradouro" />
  </div>
  <div class="bn-form-group col-md-4">
    <label class="form-label"><b>Complemento</b></label>
    <input type="text" class="form-control" name="complemento"
           [(ngModel)]="operacao.enderecoSedeClienteFinal.complemento" [disabled]="!modoEdicao && !emInclusao"
           [bnComparacaoA]="operacao.enderecoSedeClienteFinal?.complemento"
           [bnComparacaoB]="model.enderecoSedeClienteFinal?.complemento" />
  </div>
  <div class="bn-form-group col-md-3">
    <label class="form-label"><b>Bairro</b></label>
    <input type="text" class="form-control" name="nomeBairro"
           [(ngModel)]="operacao.enderecoSedeClienteFinal.nomeBairro" [disabled]="!modoEdicao && !emInclusao"
           [required]="operacao.codigoTipoOperacao == 'L'"
           [bnComparacaoA]="operacao.enderecoSedeClienteFinal?.nomeBairro"
           [bnComparacaoB]="model.enderecoSedeClienteFinal?.nomeBairro" />
  </div>
  <div class="bn-form-group col-md-2">
    <label class="form-label"><b>CEP</b></label>
    <input type="text" class="form-control" name="cep" [(ngModel)]="operacao.enderecoSedeClienteFinal.cep"
           bnMask="CEP" [disabled]="!modoEdicao && !emInclusao" [required]="operacao.codigoTipoOperacao == 'L'"
           [bnComparacaoA]="operacao.enderecoSedeClienteFinal?.cep"
           [bnComparacaoB]="model.enderecoSedeClienteFinal?.cep" />
  </div>
  <div class="bn-form-group col-md-4 offset-md-1"  *ngIf="modalidadeSebrae">
    <label class="form-label"><b>Telefone Beneficiário</b></label>
    <input type="text" bnMask="CELULAR" class="form-control" name="telefoneBeneficiario" maxlength="20"
      [(ngModel)]="operacao.telefoneBeneficiario" [disabled]="!campoHabilitado('telefoneBeneficiario')"
      [required]="operacao.codigoTipoOperacao == 'L' || operacao.codigoTipoOperacao == 'R'"
      [bnComparacaoA]="operacao.telefoneBeneficiario" [bnComparacaoB]="model.telefoneBeneficiario" />
  </div>
  <div class="bn-form-group col-md-2"  *ngIf="modalidadeSebrae">
    <label class="form-label"><b>Agência</b></label>
    <input type="text" bnMask="INTEIRO" class="form-control" name="numeroAgenciaBeneficiario"
      [(ngModel)]="operacao.numeroAgenciaBeneficiario" [disabled]="!campoHabilitado('numeroAgenciaBeneficiario')"
      [required]="operacao.codigoTipoOperacao == 'L' || operacao.codigoTipoOperacao == 'R'"
      [bnComparacaoA]="operacao.numeroAgenciaBeneficiario" [bnComparacaoB]="model.numeroAgenciaBeneficiario" />
  </div>
  <div class="bn-form-group col-md-6"  *ngIf="modalidadeSebrae">
    <label class="form-label"><b>Nome Sócio</b></label>
    <input type="text" class="form-control" name="nomeSocioBeneficiario"
      [(ngModel)]="operacao.nomeSocioBeneficiario" [disabled]="!campoHabilitado('nomeSocioBeneficiario')"
      [required]="operacao.codigoTipoOperacao == 'L' || operacao.codigoTipoOperacao == 'R'"
      [bnComparacaoA]="operacao.nomeSocioBeneficiario" [bnComparacaoB]="model.nomeSocioBeneficiario" />
  </div>
  <div class="bn-form-group col-md-2"  *ngIf="modalidadeSebrae">
    <label class="form-label"><b>CPF Sócio</b></label>
    <input type="text" bnMask="CPF" class="form-control" name="cpfSocioBeneficiario"
      [(ngModel)]="operacao.cpfSocioBeneficiario" [disabled]="!campoHabilitado('cpfSocioBeneficiario')"
      [required]="operacao.codigoTipoOperacao == 'L' || operacao.codigoTipoOperacao == 'R'"
      [bnComparacaoA]="operacao.cpfSocioBeneficiario" [bnComparacaoB]="model.cpfSocioBeneficiario" />
  </div>
  <div class="bn-form-group col-md-2"  *ngIf="modalidadeSebrae && (operacao.codigoTipoOperacao == 'L' || operacao.codigoTipoOperacao == 'R')">
    <label class="block form-label"><b>Data Nasc. Sócio  </b><i class="fa fa-question-circle help-subtitulo" placement="bottom"
                                                                ngbTooltip="Preencher com a Data de nascimento."></i></label>
    <bn-datepicker name="dataNascSocioBeneficiario"
                   [(ngModel)]="operacao.dataNascSocioBeneficiario"
                   [disabled]="!campoHabilitado('dataNascimentoSocioBeneficiario')"
                   [required]="operacao.codigoTipoOperacao == 'L' || operacao.codigoTipoOperacao == 'R'"
                   [bnComparacaoA]="operacao.dataNascSocioBeneficiario"
                   [bnComparacaoB]="model.dataNascSocioBeneficiario"></bn-datepicker>
  </div>
  <div class="bn-form-group col-md-2"  *ngIf="modalidadeSebrae && (operacao.codigoTipoOperacao == 'L' || operacao.codigoTipoOperacao == 'R')">
    <label class="block form-label"><b>Gênero</b></label>
    <select class="form-control" id="generoSocioBeneficiario" name="generoSocioBeneficiario"
            [(ngModel)]="operacao.generoSocioBeneficiario" (change)="atribuirNovoValorGenero($event.target.value)"
            [disabled]="!campoHabilitado('tipoGeneroSocioBeneficiario')" #generoSocioBeneficiarioSelect="ngModel"
            [required]="operacao.codigoTipoOperacao == 'L' || operacao.codigoTipoOperacao == 'R'"
            [bnComparacaoA]="getNomeGenero(operacao.generoSocioBeneficiario)"
            [bnComparacaoB]="getNomeGenero(model.generoSocioBeneficiario)">
      <option value=""></option>
      <option [value]="generoSocio.valor" *ngFor="let generoSocio of generoSocios">
        {{generoSocio.nome}}</option>
    </select>
  </div>
  <div class="bn-form-group col-md-5"  *ngIf="modalidadeSebrae">
    <label class="form-label"><b>E-mail Beneficiário</b></label>
    <input type="email" pattern="[^@\s]+@[^@\s]+\.[^@\s]+"  class="form-control" name="emailBeneficiario"
      [(ngModel)]="operacao.emailBeneficiario"  [bnComparacaoA]="operacao.emailBeneficiario"
      [required]="operacao.codigoTipoOperacao == 'L' || operacao.codigoTipoOperacao == 'R'"
      [bnComparacaoB]="model.emailBeneficiario" [disabled]="!campoHabilitado('emailBeneficiario')" />
  </div>
</div>

<ng-template #carregando>
  <div class="loading-pesquisa">
    <i class="bn-loading"></i>
  </div>
</ng-template>
